import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setEmptyCurrentContact } from './contactsSlice'

import Modal from '@/components/ui/Modal'
import ContactForm from './form/ContactForm'

import { PlusIcon } from '@heroicons/react/24/outline'

const addContactButton = ({disabled = false}) => {
  const dispatch = useDispatch()
  const isCreating = useSelector((state) => state.contacts.loadingStatus.createContact)
  const success = useSelector((state) => state.contacts.requestStatus.success)

  const { isOpen, handleShow, handleHide, dialogRef } = Modal.useModal()

  useEffect(() => {
    // Si le formulaire a été soumis avec succès (isCreating est passé à false ET success est true)
    if (!isCreating && success && isOpen) {
      closeModal()
    }
  }, [isCreating, success])

  const openModal = () => {
    dispatch(setEmptyCurrentContact({type: "PersonnePhysique"}))
    handleShow()
  }
  const closeModal = () => {
    dispatch(setEmptyCurrentContact())
    handleHide()
  }

  return (
    <>
      <button 
        className="btn btn-primary" 
        onClick={openModal}
        disabled={disabled}
      >
        <PlusIcon className="h-5 w-5 mr-1"/>
        Ajouter un contact
      </button>

      <Modal
        open={isOpen}
        onClose={closeModal}
        ref={dialogRef}
        backdrop={false}
        className="max-w-full rounded-none"
      >
        <Modal.Header showCloseButton={false} />
        <Modal.Body>
          <ContactForm onSuccess={closeModal} onClose={closeModal}/>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default addContactButton